export const WIDGET_PATIENTS_TO_CALL = 'widget-patients-to-call';
export const WIDGET_PATIENTS_TO_CALL_RESULT = `${WIDGET_PATIENTS_TO_CALL}/result`;
export const WIDGET_PATIENTS_TO_CALL_ERROR = `${WIDGET_PATIENTS_TO_CALL}/error`;
